import React from 'react';
import { Table, Button, Typography } from 'antd';
import AdminNav from './AdminNav';
import { getChallengeRegistrations, exportChallengeRegistrationsCsv } from './api';
import moment from 'moment';

const AdminChallengeRegistrations = () => {
  const [loading, setLoading] = React.useState(true);
  const [rows, setRows] = React.useState([]);

  const load = async () => {
    setLoading(true);
    const data = await getChallengeRegistrations();
    const table = (data || []).map((r, idx) => ({
      key: idx + 1,
      ...r,
    }));
    setRows(table);
    setLoading(false);
  };

  React.useEffect(() => {
    load();
  }, []);

  const handleExport = async () => {
    await exportChallengeRegistrationsCsv();
  };

  const columns = [
    { title: 'Sr. No', dataIndex: 'key' },
    { title: 'First Name', dataIndex: 'firstName' },
    { title: 'Last Name', dataIndex: 'lastName' },
    { title: 'Email', dataIndex: 'email' },
    { title: 'Age Group', dataIndex: 'ageGroup' },
    { title: 'Income', dataIndex: 'annualHouseholdIncome' },
    { title: 'Gender', dataIndex: 'gender' },
    { title: 'Zip Code', dataIndex: 'zipCode' },
    {
      title: 'Subscribed',
      dataIndex: 'agreeToSubscribe',
      render: (v) => (v ? 'Yes' : 'No'),
    },
    {
      title: 'Registered On',
      dataIndex: 'createdAt',
      render: (t) => moment(t).format('LLL'),
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
  ];

  return (
    <div>
      <AdminNav />
      <div style={{ padding: 24 }}>
        <Typography.Title level={3}>Challenge Registrations</Typography.Title>
        <div style={{ marginBottom: 12 }}>
          <Button type="primary" onClick={handleExport}>
            Export to Excel (CSV)
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={load}>
            Refresh
          </Button>
        </div>
        <Table
          loading={loading}
          dataSource={rows}
          columns={columns}
          pagination={{ pageSize: 10 }}
        />
      </div>
    </div>
  );
};

export default AdminChallengeRegistrations;
